import { css } from 'emotion';
import React, { useEffect, useState } from 'react';
import { SubmitButton as StyledSubmitButton } from 'components/EpisodeEditorPublish/components/InteractivePoll/styles';
import { Loading } from 'screens/SettingsScreen/components/Loading';

export function SubmitButton(props: {
  isSubmitting: boolean;
  pristine: boolean;
  onClick: (e: React.FormEvent) => void;
}) {
  const { pristine, isSubmitting, onClick } = props;
  const [isActive, setIsActive] = useState(false);
  function getText() {
    if (isActive && isSubmitting) {
      return (
        <>
          <Loading
            className={css`
              width: 24px;
              margin-right: 8px;
            `}
          />
          Saving...
        </>
      );
    }
    return 'Create question';
  }

  useEffect(() => {
    if (!isSubmitting) {
      setIsActive(false);
    }
  }, [isSubmitting]);

  return (
    <StyledSubmitButton
      kind="button"
      color="purple"
      type="button"
      isDisabled={isSubmitting || pristine}
      onClick={e => {
        setIsActive(true);
        onClick(e);
      }}
    >
      {getText()}
    </StyledSubmitButton>
  );
}
